import { useContext, useEffect, useState } from 'react';
import GridProvider from './components/GridProvider';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import Spinner from '../../UI/Modal/Spinner';
import { TabContext } from '../../../Context/TabContext';
import Zaglavlje from './components/Zaglavlje';
import { useTranslation } from 'react-i18next';

const INITIAL_VALUES = {
  datumOd: new Date(new Date().setMonth(new Date().getMonth() - 1)),
  datumDo: new Date(),
  statusZahteva: [],
};

const Porudzbenice = () => {
  const { t, i18n } = useTranslation();
  const { addTab } = useContext(TabContext);

  const { getData, isLoading } = useHttp('');
  const [filterValues, setFilterValues] = useState(INITIAL_VALUES);
  const [gridData, setGridData] = useState([]);

  const vratiGridZahteva = async () => {
    const config = {
      url: urls.PREGLED_NARUDZBINE,
      method: 'POST',
      data: {
        datumOd: filterValues.datumOd,
        datumDo: filterValues.datumDo,
        lista: filterValues.statusZahteva || [],
        idKupca: +localStorage.idFirme,
        idKorProm: +localStorage.idKorisnika,
        metadata: i18n.language,
      },
    };
    const response = await getData(config);
    // console.log(response);
    if (response) {
      setGridData(response);
    }
  };

  useEffect(() => {
    vratiGridZahteva();
  }, [i18n.language]);

  const handlePretrazi = () => {
    vratiGridZahteva();
  };
  const handleClickDokument = (item) => {
    // console.log(item);
    const tab = {
      title: 'Porudžbenica pregled',
      icon: 'fas fa-clipboard',
      type: 10015,
      data: item,
    };
    addTab(tab);
  };
  return (
    <div>
      {isLoading && <Spinner />}
      <Zaglavlje
        handlePretrazi={handlePretrazi}
        setFilterValues={setFilterValues}
        filterValues={filterValues}
        vratiGridZahteva={vratiGridZahteva}
      />
      <GridProvider
        data={gridData}
        isLoading={isLoading}
        handleClickDokument={handleClickDokument}
      />
    </div>
  );
};

export default Porudzbenice;
